import React, { Component } from "react";

import { ReactComponent as ScratchCardsIcon } from "assets/icons/scratch cards.svg";
import { ReactComponent as SlotIconActive } from "assets/icons/Slots-active.svg";
import { ReactComponent as SlotIconInactive } from "assets/icons/Slots-inactive.svg";
import { ReactComponent as TableGamesIconActive } from "assets/icons/TableGames-active.svg";
import { ReactComponent as TableGamesIconInactive } from "assets/icons/TableGames-inactive.svg";
import { ReactComponent as VirtualSportsIconActive } from "assets/icons/VirtualSports-active.svg";
import { ReactComponent as VirtualSportsIconInactive } from "assets/icons/VirtualSports-inactive.svg";
import { ReactComponent as CrashGamesIconActive } from "assets/icons/CrashGames-active.svg";
import { ReactComponent as CrashGamesIconInactive } from "assets/icons/CrashGames-inactive.svg";
import { ReactComponent as LiveCasinoIconActive } from "assets/icons/LiveCasino-active.svg";
import { ReactComponent as LiveCasinoIconInactive } from "assets/icons/LiveCasino-inactive.svg";
import { ReactComponent as InstantWinIconActive } from "assets/icons/InstantWin-active.svg";
import { ReactComponent as InstantWinIconInactive } from "assets/icons/InstantWin-inactive.svg";
import { ReactComponent as LotteryIconActive } from "assets/icons/Lottery-active.svg";
import { ReactComponent as LotteryIconInactive } from "assets/icons/Lottery-inactive.svg";
import { ReactComponent as ShootingIconActive } from "assets/icons/Shooting-active.svg";
import { ReactComponent as ShootingIconInactive } from "assets/icons/Shooting-inactive.svg";
import { ReactComponent as GameShowsIconActive } from "assets/icons/GameShows-active.svg";
import { ReactComponent as GameShowsIconInactive } from "assets/icons/GameShows-inactive.svg";
import { ReactComponent as EsportsIconActive } from "assets/icons/ESports-active.svg";
import { ReactComponent as EsportsIconInactive } from "assets/icons/Esports-inactive.svg";
import { ReactComponent as SportsIconActive } from "assets/icons/Sports-active.svg";
import { ReactComponent as SportsIconInactive } from "assets/icons/Sports-inactive.svg";
import { HomeIcon, BingoIcon, VirtualGamesIcon } from "component/icons";

import "component/lobby/GameNavigation/styles.scss";

class GameNavigation extends Component {
  constructor(props) {
    super(props);
    this.setActiveCategory = this._setActiveCategory.bind(this);
  }

  _setActiveCategory(content) {
    if (this.props.setActiveCategory) {
      this.props.setActiveCategory(content);
    }
  }

  renderIcon(content, key) {
    let isActive;
    try {
      isActive = this.props.activeCategory.get("rel") === content.get("rel");
    } catch (err) {}

    let Icon;

    switch (content.get("rel")) {
      case "wl-slots":
        Icon = isActive ? SlotIconActive : SlotIconInactive;
        break;
      case "wl-tableGames":
        Icon = isActive ? TableGamesIconActive : TableGamesIconInactive;
        break;
      case "wl-virtualSportsGames":
        Icon = isActive ? VirtualSportsIconActive : VirtualSportsIconInactive;
        break;
      case "wl-virtualGameGames":
        Icon = VirtualGamesIcon;
        break;
      case "wl-instantWinGames":
        Icon = isActive ? InstantWinIconActive : InstantWinIconInactive;
        break;
      case "wl-bingoGames":
        Icon = BingoIcon;
        break;
      case "wl-shootingGames":
        Icon = isActive ? ShootingIconActive : ShootingIconInactive;
        break;
      case "wl-scratchCardGames":
        Icon = ScratchCardsIcon;
        break;
      case "wl-liveCasinoGames":
        Icon = isActive ? LiveCasinoIconActive : LiveCasinoIconInactive;
        break;
      case "wl-esportsGames":
        Icon = isActive ? EsportsIconActive : EsportsIconInactive;
        break;
      case "wl-SPORTS":
        Icon = isActive ? SportsIconActive : SportsIconInactive;
        break;
      case "wl-CRASH":
        Icon = isActive ? CrashGamesIconActive : CrashGamesIconInactive;
        break;
      case "wl-GAME_SHOW":
        Icon = isActive ? GameShowsIconActive : GameShowsIconInactive;
        break;
      case "wl-lotteryGames":
        Icon = isActive ? LotteryIconActive : LotteryIconInactive;
        break;
      default:
        Icon = HomeIcon;
        break;
    }

    return (
      <li
        className={`nav-link text-center ${isActive ? "selected" : ""}`}
        key={key}
        onClick={() => {
          this.setActiveCategory(content);
        }}
      >
        <Icon color="rgba(255,204,0,1)" selectedcolor="rgba(255,204,0,1)" />
        <div className="category-name">{content.get("name")}</div>
      </li>
    );
  }

  render() {
    return (
      <div className="lobby-game-navigation">
        <ul className="nav justify-content-center">
          {this.props.content.map((content, key) => {
            return this.renderIcon(content, key);
          })}
        </ul>
      </div>
    );
  }
}

export default GameNavigation;
